import React, { Component } from 'react';
import { compose } from 'recompose';
import { Card } from 'semantic-ui-react';
import EmptyState from './empty-state';
import InstagramProfileData from 'dyzio-shared-components/lib/components/instagram-profile-data';
import withInfluencerData from '../../hocs/data/with-influencer-data';

const STATUS_APPROVED = 'APPROVED';

class ACRDemographicsWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      influencer: null,
      isLoading: true,
      isError: false,
    };
  }

  componentDidMount() {
    const { influencer, userInfo, getInfluencerById, campaign } = this.props;
    getInfluencerById(influencer.id).then(influencer => {
      this.setState({
        influencer,
        isLoading: false,
      });
      return influencer;
    }).catch(() => {
      this.setState({
        isError: true,
        isLoading: false,
      });
    });
  }

  render() {
    const { isLoading, influencer } = this.state;
    const { userInfo, campaign } = this.props;
    const { approvalStatus } = campaign;
    const isCampaignApproved = approvalStatus === STATUS_APPROVED;
    const props = { influencer, userInfo };
    return (
      <Card.Content>
        { !isLoading && isCampaignApproved && influencer.instagramAuthorised &&
          <InstagramProfileData
            {...props}
            disableBorders
            usedByACRCampaign
          />
        }
        {
          !isLoading && (!isCampaignApproved || !influencer.instagramAuthorised) &&
          <EmptyState name={influencer.name} />
        }
      </Card.Content>
    );
  }
}


export default compose(
  withInfluencerData,
)(ACRDemographicsWrapper);



/** WEBPACK FOOTER **
 ** ./src/containers/acr-demographics-wrapper/index.js
 **/